import { Slider } from "@components/atoms/Slider"
import { BlogPostTile } from "@components/news/BlogPostTile"
import { LargeBlogTile } from "@components/news/LargeBlogTile"
import { Button } from "@components/ui/Button"
import { defineBlock, EditableText } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Latest News",
  description: "Display the latest news",
  icon: "welcome-write-blog",
  category: "embed",
  tags: ["#homepage", "#subpage-layout"],
  flags: {
    fullWidth: true,
    marginRule: "featured-card",
  },
}

export default defineBlock("homepage/latest-news", (props) => {
  const posts = props.posts

  if (props.posts?.length === 1) {
    return (
      <div>
        <div className="w-grid mx-auto">
          <LargeBlogTile {...props.posts[0]!} />
        </div>
      </div>
    )
  }

  return (
    <div data-mixpanel-block="Latest News">
      <div className="w-grid mx-auto flex justify-between items-center mb-4">
        <div className="col-span-9">
          <EditableText as="h2" store="title" defaultValue="Latest News" className="type-title-m" plainText />
        </div>
        <div className="col-span-3 flex items-end">
          <Button href="/blog/" variant="default" rightIcon="chevronRight">
            See all
          </Button>
        </div>
      </div>
      <Slider arrows gridInsert scrollerClass="flex gap-grid-gutter px-grid-margin-full">
        {posts?.map((post) => (
          <div className="flex-none w-cols-8 md:w-cols-4 py-[10px]" key={post?.uri}>
            <BlogPostTile {...post!} />
          </div>
        ))}
      </Slider>
    </div>
  )
})
